import React, { Component } from 'react';
import Layout from '../../common/Layout';
import PropTypes from 'prop-types';
// import { Query } from "@apollo/client/react/components"; // TODO: Replaced with REST hook
import DataTable from '../../common/components/data-table/DataTable';
import Fab from "@material-ui/core/Fab";
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import EventIcon from '@material-ui/icons/Event';
import plusButtonStyle from '../../settings/otherStyles';
import { client } from '../../settings/apollo';
import CSVService from '../CSVservice';
import AdminSettingsNavigation from '../adminSettings/AdminSettingsNavigation';
import '../users/UserList.css';
import { useCoaches } from "../../hooks/useCoaches";
import { useUpdateExpirationDate } from "../../hooks/useUpdateExpirationDate";
import CalendarDialog from '../../common/components/Dialogs/CalendarDialog/CalendarDialog';
import moment from 'moment';
import Swal from 'sweetalert2';
// import { GET_COACHES, GET_COACHES_TABLE } from './graphql/queries'; // TODO: Replaced with REST hook
import LoadingSpinner from '../../common/components/LoadingSpinner/LoadingSpinner';
import SimpleSearch from '../../common/components/data-table/SimpleSearch';
import useAppStore from '../../store/appStore';
import { RolesTypes } from "../../constants/roles";

const columns = [
  "sigla",
  "name",
  "surname",
  "email",
  "expirationDate",
  "actions"
];

// Wrapper component to use hooks with class component for DataTable
const CoachesDataWrapper = ({ name, page, courseGroups, userGroup, component }) => {
  const { data: coachesData, isLoading, error } = useCoaches({ 
    name, 
    page
  });

  const updateExpirationDate = useUpdateExpirationDate();

  // Pass the mutation function to the component
  component.updateExpirationDateMutation = updateExpirationDate;

  if (isLoading) return <LoadingSpinner boxed={true} styles={{ paddingTop: 40, marginTop: 15, marginBottom: 30 }} />;
  if (error) return `Error! ${error.message}`;
  if (coachesData?.coaches === null) return <b>This feature is available just to Administrators</b>;

  // Transform the data to remove GraphQL artifacts and format courseGroups properly
  const transformedData = {
    ...coachesData.coaches,
    records: coachesData.coaches.records.map(record => ({
      ...record,
      courseGroups: record.courseGroups?.map(cg => cg.name).join(', ') || ''
    }))
  };

  return (
    <DataTable
      key={`coaches-table-${page}-${coachesData?.coaches?.records?.length || 0}-${name || 'all'}`}
      header="Users"
      editUrl="/admin-settings/users/"
      pages={coachesData?.coaches?.pages}
      columns={columns}
      records={transformedData}
      deleteRow={component._deleteRow}
      keyColumn="_id"
      page={page}
      first={component._first}
      last={component._last.bind(component, coachesData?.coaches?.pages)}
      next={component._nextPage}
      previous={component._previousPage}
      checkboxes={true}
      selectedIndexes={component.state.selectedIndexes}
      onSelectedIndex={component.handleSelectedIndexes}
      showDeleteIcon={component.handleDeleteAction}
      highlightRecord={component.highlightRecord}
    />
  );
};

// Wrapper component to use hooks with class component for CSV Download
const CoachesCSVWrapper = ({ name, courseGroups, userGroup }) => {
  const { refetch } = useCoaches({ 
    name, 
    page: null, // No pagination for CSV - get all records
    enabled: false // Don't fetch automatically
  });

  const handleCalculateData = async () => {
    try {
      const { data: coachesData } = await refetch();
      
      if (coachesData?.coaches?.records) {
        let usersList = [];
        coachesData.coaches.records.map((item, index) => {
          usersList.push({
            _id: item._id,
            name: item.name,
            surname: item.surname,
            sigla: item.sigla,
            email: item.email,
            _role: item.userRole,
            _userGroup: item.courseGroups?.map(cg => cg.name).join(', ') || '',
            PrivacyPolicy: item.privacyPolicy,
            ProfileScorecard: item.profileScorecard,
            PublishAchievement: item.publishAchievement
          });
          return null;
        });
        return usersList;
      }
    } catch (error) {
      console.error('Error fetching coaches data:', error);
    }
    return [];
  };

  return (
    <CSVService
      label="Download Users Data"
      fileName="GAMSUserData.csv"
      onClickCalculate={handleCalculateData}
    />
  );
};

// TODO: Replaced GraphQL mutation with REST hook
/*
const UPDATE_USERS_EXPIRATION_DATE = gql`
  mutation updateUsersExpirationDate($input: UsersExpirationDateInput) {
    updateUsersExpirationDate(input: $input)
  }
`;
*/

class Coaches extends Component {
  static propTypes = {
    page: PropTypes.number
  };

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      page: props.match.params.page ? parseInt(props.match.params.page) : 0,
      selectedIndexes: [],
      users: []
    };
    this.datePickerDialog = React.createRef();
    this.openDatePickerDialog = this.openDatePickerDialog.bind(this);
    this.handleSelectedIndexes = this.handleSelectedIndexes.bind(this);
    this.handleDeleteAction = this.handleDeleteAction.bind(this);
    this._nextPage = this._nextPage.bind(this);
    this._previousPage = this._previousPage.bind(this);
    this._add = this._add.bind(this);
    this._first = this._first.bind(this);
    this._last = this._last.bind(this);
    this._first = this._first.bind(this);
    this._keyPress = this._keyPress.bind(this);
    this.today = moment();
    this.client = client;
  }

  _previousPage(e) {
    e.preventDefault()
    if (this.state.page > 1) {
      this.setState({ page: this.state.page - 1 });
    } else {
      this.setState({ page: 0 });
    }
  }

  _nextPage(e) {
    e.preventDefault();
    this.setState({ page: this.state.page + 1 });
  }

  _first(e) {
    e.preventDefault();
    this.setState({ page: 0 });
  }

  _last(pages, e) {
    e.preventDefault();
    this.setState({ page: pages - 1 });
  }

  _add(event) {
    this.props.history.push('/admin-settings/register');
  }

  _keyPress(e) {
    if (e.keyCode === 13) {
      this.setState({
        name: e.target.value,
        page: 0
      });
    }
  }

  isSelected(user) {
    return user._id.this.state.selectedIndexes;
  }

  handleDateChange = date => {
    this.setState({ selectedIndexes: [], users: [] });

    const ids = this.state.selectedIndexes.map(index => {
      return this.state.users[index]._id;
    });
    
    // Use REST API mutation instead of GraphQL
    this.updateExpirationDateMutation.mutate(
      { expirationDate: date, ids: ids },
      {
        onSuccess: () => {
          Swal.fire({
            type: 'success',
            title: 'Expiring date changed.',
            showConfirmButton: false,
            timer: 1500
          });
        },
        onError: (error) => {
          console.log("error changing date", error);
          Swal.fire({
            type: 'error',
            title: 'Error changing expiration date',
            text: error.message,
            showConfirmButton: true
          });
        }
      }
    );
  };

  openDatePickerDialog = () => {
    if (this.state.selectedIndexes.length === 0) {
      Swal.fire({
        type: "warning",
        text: "Select users first.",
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: "Close"
      });
      return;
    }
    this.datePickerDialog.current.open();
  };

  handleSelectedIndexes = (selectedIndexes, records) => {
    selectedIndexes.map(i => console.log("selected record", records[i]));
    this.setState({ selectedIndexes: selectedIndexes });
    this.setState({ users: records });
  };

  handleDeleteAction = () => {
    return false;
  };

  highlightRecord(record) {
    return moment(record.expirationDate).isBefore(this.today);
  }

  render() {
    // Get user data from Zustand store instead of MY_DATA GraphQL query
    const user = useAppStore.getState().user;
    
    // Early return if no user data
    if (!user || !user.me) return <LoadingSpinner styles={{ paddingTop: 30 }}/>;
    
    const userData = user.me;
    const UserGroupList = [];
    const courseGroups = userData.courseGroups?.map((item) => item) || [];
    courseGroups.map((item) => {
      UserGroupList.push(item._id);
      return null;
    });

    return (
      <Layout name="Users">
        <div className="user-list">
          <div className="wizard-container">
            {userData.userRole === RolesTypes.SUPERUSER ? (
              <Fab
                onClick={this._add}
                color="primary"
                aria-label="Add"
                className={plusButtonStyle.fab}
              >
                <AddIcon />
              </Fab>
            ) : null}

            <AdminSettingsNavigation path={this.props.match.path} />

            <div className="row justify-content-end user-list__controls">
              <div className="col-xl-3 col-lg-12 text-right">
                {userData.userRole === RolesTypes.SUPERUSER ? 
                <Button
                variant="contained"
                color="primary"
                size="medium"
                className="btn-date"
                onClick={this.openDatePickerDialog}
              >
                <EventIcon /><span>Change expiration date</span>
              </Button>
              : null}
              </div>
              <div className="col-xl-2 col-lg-6">
                <SimpleSearch keyPress={this._keyPress} />
              </div>
            </div>

            <CoachesDataWrapper
              name={this.state.name}
              page={this.state.page}
              courseGroups={UserGroupList}
              userGroup={this.state.userGroup}
              component={this}
            />
            
            <CoachesCSVWrapper
              name={this.state.name}
              courseGroups={UserGroupList}
              userGroup={this.state.userGroup}
            />
          </div>

          <CalendarDialog
            value={moment()}
            onHandleDateChange={this.handleDateChange}
            ref={this.datePickerDialog}
            styleDialog={{ display: "none" }}
          />
        </div>
      </Layout>
    );
  }
}

export default Coaches;
